const cv = 

{
    "meta": {
      "theme": "elegant"
    },
    
    "basics": {
      "foto": "",
      "nombre": "Ej.: Juan Pérez",
      "puesto": "Ej.: Empleado administrativo",
      "descripción": "(MÁX. 250 palabras) Ej.: Empleado administrativo con más de cinco años de experiencia. Graduado en [TÍTULO] por [NOMBRE DE INSTITUCIÓN]. Perfil metódico orientado al logro de objetivos.",
      "teléfono":"Ej.: +54 (0341) 4 555 555",
      "email": "ejemplo@gmail.com",
      "location": {
        "localidad": "Ej.: Rosario, Santa Fe",
        "CP": "Ej.: 2000",
      },
      "linkedin": "Ej.: https://linkedin.com/usuario",
    },
    "education": [
      {
        "institución": "Ej.: Universidad Nacional de Rosario",
        "título": "Ej.: Administración de empresas",
        "campo": "Ej.: Administración y Finanzas",
        "desde": "2009-12-12",
        "hasta": "2008-02-12", 
      }
    ],
    "references": [
      {
        "recomendación": "Juan fue contratado como cadete administrativo y, luego de un crecimiento profesional, asumió el cargo de Administrativo junior. Juan es muy responsable, dedicado y sabe trabajar en equipo. Recomiendo ampliamente su contratación.",
        "responsable": "Marcos Flores, Gerente de Contaduría y finanzas en Banco Municipal."
      },
    ],
    "skills": [
      {
        "habilidad/conocimiento": [
          "Inglés",
        ],
        "nivel": "Intermedio",
      },
    ],
    "awards": [
      {
        "título": "Defender of the Internet",
        "institución": "Fight For The Future",
        "fecha de inicio": "2020-05-05",
        "fecha de finalización": ""
      }
    ],
    "work": [
      {  
        "cargo": "Administrativo junior",
        "empleador": "[NOMBRE DE EMPRESA/ CONTRATANTE] Ej.: Banco Municipal",
        "tareas": "Ejemplo de tareas: Trámites bancarios y cobranzas a distintos clientes; control de facturación; pagos a proveedores y gestion de ordenes de pagos; control de reportes de gastos",
        "website": "https://tokenized.com/",
        "localidad": "Ej.: Rosario, Santa Fe",
        "inicio": "20/03/2016",
        "finalización": "08/09/2020",
        "habilidades": ["React", "Redux", "SCSS", "Product"]
      },
       
    ],
    "interests": [
      {
        "actividad": "Ej.: Tocar la guitarra"
      },
    ]
  }

  export {cv};